/** Глобальні ролі облікового запису (auth.user_account.global_role; прототип v4 adm-groles) у порядку карток і вибору. */
export const globalRoles: readonly string[] = ['Platform admin', 'Customizer', 'None'];

/** Ключ i18n глобальної ролі: «Platform admin» → platformAdmin. Чиста функція. */
export const globalRoleKey = (role: string): string => (role === 'Platform admin' ? 'platformAdmin' : role === 'Customizer' ? 'customizer' : 'none');
